export const NUMBER_OF_VIDEOS = 10;
export const AUDIO_ONLY = false
const TEST_VIDEO_FOLDER = 'mickan-test'
export const VIDEO_BASE_URL = `https://video-quality-bucket.svt.se/video-quality-test-int/${TEST_VIDEO_FOLDER}/`;
export const IS_CLOSED = false; // toggla om test är öppet eller inte genom att ändra den här variabeln
export const TEST_REASON = "TEST." // Byt ut syftet med testet, allt annat är generiskt.
export const ALLOW_COMMENTS = true; // toggla fritextkommentarer
export const QUESTION = "Vilket alternativ ser bäst ut"


// WEBPACK FOOTER //
// ./src/services/config.js